"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var _FormButton = _interopRequireDefault(require("../FormButton"));

/**
 * Vytvoří button pro dialog. Props stejne jako ostatni buttony => color, variant, fullWidth, atd..
 *
 */
var DialogButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["color", "variant"]);
  return /*#__PURE__*/_react.default.createElement(_FormButton.default, (0, _extends2.default)({
    ref: ref,
    color: color,
    variant: variant
  }, rest));
});

DialogButton.displayName = 'DialogButton';

var _default = (0, _withThemeProps.default)({
  name: 'SxDialogButton'
})(DialogButton);

exports.default = _default;